let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kqv8D")).then(() => parcelRequire('5pMQO'));